import React from "react";
import { GetActiveGrantorList } from "../../../redux/features/GrantorService";
import UserManagementWrapper from "../../Common/UserManagementWrapper";

const ArchivedGrantor = ({ filteredData }) => { // NOSONAR
  return (
    <UserManagementWrapper
      fetchFunction={GetActiveGrantorList}
      fetchArgs={{
        search: "",
        role: 2,
        status: "0",
      }}
      selector={(state) => state.grantors.getGrantorListing}
      detailRoute="/grantor"
      filteredData={filteredData}
    />
  );
};

export default ArchivedGrantor;
